import MaterialStock from "./MaterialStock";

export default function PurchaseOrders() {
  return <MaterialStock forcedEntryType="order" />;
}
